

$(document).ready(function() {
  
  /* detect mobile */
var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
  if(isMobile) {
    console.log("is mobile");
    //$('#collapseReviewHighlight').removeClass("show");
    $(".collapse").collapse("hide");
  }
  /* END detect mobile */
/*
  // Toggle plus minus icon on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function() {
    $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
  }).on('hide.bs.collapse', function() {
    $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
  });
  */
  /*	product-main.liquid	*/
  /*	END product-main.liquid	*/
  
  /*	product-ingredients.liquid	*/
  /*	END product-ingredients.liquid	*/
  
  $('.mobIngredSlider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: true,
    prevArrow: '<div class="prevArrow"><img src="https://cdn.shopify.com/s/files/1/1600/4387/files/Arrow_Icon.svg?v=1602204505" alt="Kindra Prev Arrow" /></div>',
    nextArrow: '<div class="nextArrow"><img src="https://cdn.shopify.com/s/files/1/1600/4387/files/Arrow_Icon.svg?v=1602204505" alt="Kindra Next Arrow" /></div>',
    responsive: [
        {
          breakpoint: 767,
           settings: {
              centerPadding: '0px',
              slidesToShow: 1,
              infinite: false,
              dots: false,
              arrows: false
          }
        }
    ]
  });

  $('.modal').on('shown.bs.modal', function (e) {
    $('.mobIngredSlider').slick('setPosition');
    $('.wrap-modal-slider').addClass('open');
  });
/*
  // Open subSaveDrawer
  $("#subSaveTrigger").click(function(){
    console.log("open subscription frequency");
    $("#subSaveDrawer").addClass("openSubSave");
    $(".slideOutCover").addClass("slideOutCoverActive");
  });
*/
  // Close subSaveDrawer
  $(".closeCart").click(function(){
    $("#subSaveDrawer").removeClass("openSubSave");
    $(".slideOutCover").removeClass("slideOutCoverActive");
  });

  // Close subSaveDrawer
  $(".btnInverse").click(function(){
    $("#subSaveDrawer").removeClass("openSubSave");
    $(".slideOutCover").removeClass("slideOutCoverActive");
  });

  $('.prodResultsMobileSlider').slick({
    slidesToShow: 1.3,
    slidesToScroll: 1,
    swipeToSlide: false,
    responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 767,
           settings: {
              infinite: false,
              dots: false,
              arrows: false
          }
        }
    ]
  });
  
/*	SUBSCRIPTION 	*/  
  $('input[name="purchase_type"]').on('change', function() {
    
    var price = $(this).next('label').find('.rc_price').text();
    var compare = $(this).next('label').find('.rc_price').attr("data-compare-price");
    
    //console.log(price);
    //console.log(compare);
    $('.price').text(price);
    $('.compareAtPrice').text(compare);
  });  
/*	END SUBSCRIPTION 	*/

});

/*	SUBSCRIPTION 	*/ 

function selectRC(frequency) {
  //console.log("frequency: " + frequency);
  var chosen = $('div[data-frquency="' + frequency + '"]');
  var current = $('.rcOption.rcChosen');
  if (chosen.hasClass("rcChosen")) {
    //console.log("already chosen");
  } else {
    current.removeClass("rcChosen");
    chosen.addClass("rcChosen");
  }
  $('option[value="'+ frequency +'"]').attr('selected', 'selected');
  //$('#rc_shipping_interval_frequency option[value="' + frequency + '"]').prop('selected', true);
  //$('#rc_shipping_interval_frequency option[value="' + frequency + '"]').val(frequency);
}



/*	END SUBSCRIPTION 	*/ 

//   HIDE AFTERPAY MESSAGE

  if ($("#rc_container").length == 0 ){
    $("#afterpay_container").removeClass("d-none");
  }
  else{
    $('input[name="purchase_type"]').on('change', function() {
      $("#afterpay_container").toggleClass("d-none");
    });
  }

//   END AFTERPAY MESSAGE

/*	NAV	*/  
  
  // Toggle product nav

    //const atcButton = $('#prodDetails input#AddToCart').offset().top + $('#prodDetails input#AddToCart').outerHeight();
    //console.log("atcButton: " + atcButton);

    var toggleNav = function(){
      
      var height = $(window).scrollTop();
      var atcButton = $('#prodDetails input#AddToCart').offset().top + $('#prodDetails input#AddToCart').outerHeight();
	  var positionAddToCart = $('.productDetailsScrollable').height();
      
      //console.log("positionAddToCart: " + positionAddToCart);
      
      
      if($(window).width() < 767) {
        if(height > atcButton) {
          $('#mobileAddToCart').removeClass('hide');
        } else {
          $('#mobileAddToCart').addClass('hide');
        }
      } else {
        if(height > atcButton) {
          $('#navbar').addClass('hide');
          $('#productNav').removeClass('hide');
        } else {
          $('#navbar').removeClass('hide');
          $('#productNav').addClass('hide');
        }
      }
      
    };  
  
  // Sticky nav styling
    var stickyNav = function(){
      
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 100) { 
          $('#productNav').addClass('sticky');
        console.log('#productNav add sticky');
          //$('#mobileAddToCart').addClass('sticky');
      } else {
          $('#productNav').removeClass('sticky'); 
        //$('#mobileAddToCart').removeClass('sticky'); 
      }
      
    };
  



  //stickyNav();
  toggleNav();
    
    $(window).scroll(function() {
      //stickyNav();
      //toggleNav();
    });


/*	END NAV	*/  
  

  /*	PREVENT SCROLL	*/ 
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; }
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';


  // call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }
  /*	END PREVENT SCROLL	*/  